import React from "react";
import XIconRemoveButton from "../../components/buttons/XIconRemoveButton";

interface Props {
  traveller: server.dto.ContactSmallV2
  onTravellerRemove: (contact: server.dto.ContactSmallV2) => void
}

const RemovableTraveller = ({ traveller, onTravellerRemove }: Props) => <div key={traveller.contactId} className="flex gap">
  <XIconRemoveButton onClick={() => { onTravellerRemove(traveller); }} />
  <div >
    {traveller.name.fullName}
    <div className="text-sublabel">{traveller.position}</div>
  </div>
</div>;

export default RemovableTraveller;
